import React from 'react';
import { I18n } from '@kineticdata/react';
import classNames from 'classnames';

export const HeaderCell = ({ onSortColumn, sortable, sorting, title }) => (
  <th
    {...(title ? { scope: 'col' } : {})}
    className={classNames({ sort: sortable })}
  >
    {!sortable ? (
      <I18n>{title}</I18n>
    ) : (
      <button
        onClick={onSortColumn}
        className={classNames('btn', {
          asc: sorting === 'asc',
          desc: sorting === 'desc',
        })}
      >
        <I18n>{title}</I18n>
      </button>
    )}
  </th>
);
